import UploadEmployer from './upload-employer';

export default UploadEmployer;